import React from "react";
import deleteModalIcon from "../../../assets/delete-modal-icon.svg";

function IgnoreStock({ isOpen, onClose, onConfirm, product }) {
  if (!isOpen) return null;

  const handleIgnore = () => {
    if (onConfirm && product) {
      onConfirm(product);
    }
    onClose();
  };

  return (
    <div
      className="lowStock-ignore-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="lowStock-ignore-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ignoreStockTitle"
      >
        <div className="modal-icon-low-stock">
          <img src={deleteModalIcon} alt="Ignore" />
        </div>
        <h3 className="modal-title-low-stock" id="ignoreStockTitle">
          Ignore Stock
        </h3>
        <p className="modal-message-low-stock">
          Are you sure you want to ignore this stocks? This action cannot be
          undone.
        </p>
        <div className="modal-actions-low-stock">
          <button type="button" className="modal-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="modal-ignore-btn"
            onClick={handleIgnore}
          >
            Ignore
          </button>
        </div>
      </div>
    </div>
  );
}

export default IgnoreStock;
